import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { loadState, removeState, saveState } from '../Common/localStorage';

const TOKEN = 'access_token';

export const isLoggedIn = () => {
  let token = loadState(TOKEN);
  return !!(token);
};

const showComponentIfEvaluateTrue = (callback = () => {
  throw new Error('Missing callback');
}) => {
  return (WrappedComponent) => {
    return class ShowComponentIfEvaluateTrue extends Component {
      render() {
        if (callback()) {
          return <WrappedComponent {...this.props}/>
        }
        return null;
      }
    }
  }
}

export const getHeaders = () => {
  const token = loadState(TOKEN);
  let headers = {};

  if (token) {
    headers.Authorization = 'Bearer ' + token;
  }
  return headers;
};

export const ShowIfAuthenticated = showComponentIfEvaluateTrue(isLoggedIn);
export const hideIfAuthenticated = showComponentIfEvaluateTrue(() => (!isLoggedIn()));

export const hasTokenManager = (WrappedComponent) => {
  return class TokenPropsProxy extends Component {
    render() {
      return (
        <TokenManager>
        { (state, methods) => (
            <WrappedComponent {...state} {...methods} {...this.props} />
          )
        }
        </TokenManager>
      );
    }
  };
};

class TokenManager extends Component {
  constructor(props) {
    super(props);
    this.setToken = this.setToken.bind(this);
    this.setAuthHeader = this.setAuthHeader.bind(this);
    this.state = {
      token: null,
      isLoggedIn: false
    };
    const token = loadState(TOKEN);
    if (token) {
      this.state.token = token;
      this.state.isLoggedIn = true;
      this.setAuthHeader(token);
    }
  }
  componentWillReceiveProps() {
    // to trigger token state refresh
    this.getToken();
  }
  getToken() {
    //TODO: check token validity before returns.
    const token = loadState(TOKEN);
    if (!token) {
      // somehow token missing
      this.setToken(null);
      return null;
    } else if (!this.state.isLoggedIn) {
      this.setState({
        token,
        isLoggedIn: true
      });
    }
    return token;
  }
  setToken(token) {
    if (token) {
      saveState(TOKEN, token);
      this.setAuthHeader(token);
      this.setState({
        token,
        isLoggedIn: true
      });
    } else {
      removeState(TOKEN);
      $.ajaxSetup({
        beforeSend: (xhr) => {
          xhr.setRequestHeader('Authorization', null);
        }
      });
      this.setState({
        token: null,
        isLoggedIn: false
      });
    }
  }
  setAuthHeader(token) {
    $.ajaxSetup({
      beforeSend: (xhr) => {
        xhr.setRequestHeader('Authorization', 'Bearer ' + token);
        xhr.setRequestHeader('Platform', 'web');
      }
    });
  }
  showLoginModal() {
    $('#modal-account').modal('show');
  }

  render() {
    const { state, setToken, showLoginModal } = this;
    return (
      <div>
        {this.props.children(state, {
          setToken,
          showLoginModal
        })}
      </div>
    );
  }
}

export default TokenManager;



// WEBPACK FOOTER //
// ./src/Auth/TokenManager.js